import { HYDRATE } from 'next-redux-wrapper'

import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { Notification } from '@/graphql/appsync-notifications'

import type {
  AppState,
  /*, AppThunk*/
} from '../store'

export interface NotificationStateIProps {
  areNotificationsMuted: boolean
  notifications: Notification[]
  notificationCount: number | undefined
}

const initialState: NotificationStateIProps = {
  areNotificationsMuted: false,
  notifications: [],
  notificationCount: undefined,
}

export const incidentSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.notifications = action.payload
    },
    setNotificationCount: (state, action: PayloadAction<number>) => {
      state.notificationCount = action.payload
    },
    setAreNotificationsMuted: (state, action: PayloadAction<boolean>) => {
      state.areNotificationsMuted = action.payload
    },
    resetNotifications: () => {
      return {
        ...initialState,
      }
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.subject,
      }
    },
  },
})

export const {
  setNotifications,
  setNotificationCount,
  setAreNotificationsMuted,
  resetNotifications,
} = incidentSlice.actions

export const selectNotifications = (state: AppState) =>
  state.notification?.notifications

export const selectNotificationCount = (state: AppState) =>
  state.notification?.notificationCount

export const selectAreNotificationsMuted = (state: AppState) =>
  state.notification?.areNotificationsMuted

// Default export for reducers is a pattern recommended by Redux
// See here: <https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#combinereducers>
// eslint-disable-next-line import/no-default-export
export default incidentSlice.reducer
